import React, { useEffect, useState } from 'react';

import fetchIkeaProductFeed from '../../../helpers/ikea-product-feed/ikea-product-feed-helpers';
import { IkeaProductCard } from '../../../helpers/ikea-product-feed/interfaces';
import { getLatestLFEvent } from '@/helpers/api/livli-family';
import { OccationEventCard } from '@/helpers/list-page/interfaces/list-card.interface';
import { ILibraryMeetingPlaceDictionary } from '@/lib/fragments/libraryMeetingPlaceDictionary';
import { CardEvent } from '@/components/cards/card-event';
import { useUrlSubDirectoryDictionary } from '@/providers/ConfigProvider';
import { getUrlSubdirectory } from '@/helpers/rendered-page-creation/get-url-subdirectories';

export interface LivliFamilyCardEventWrapperProps {
  businessUnitCode?: string;
  node_locale: string;
  cardIndex: number;
  dictionary?: ILibraryMeetingPlaceDictionary;
  isLivliFamily?: boolean;
}

const LivliFamilyCardEventWrapper = ({
  businessUnitCode,
  node_locale,
  dictionary,
  isLivliFamily,
}: LivliFamilyCardEventWrapperProps) => {
  const [eventCard, SetEventCard] = useState<OccationEventCard>();
  const urlSubDirectorydictionary = useUrlSubDirectoryDictionary();
  const urlSubdirectory = getUrlSubdirectory(
    urlSubDirectorydictionary,
    node_locale,
    'MeetingPlacePageEvent',
  );

  useEffect(() => {
    const getLatestLFData = async () => {
      const livliFamilyEvent = await getLatestLFEvent(
        {},
        {
          mpId: businessUnitCode || '',
          eventType: 'Livli Family',
          locale: node_locale,
        },
      );

      if (livliFamilyEvent?.shareUrl) {
        const lastSegment = livliFamilyEvent.shareUrl.split('/').pop();
        const slug = node_locale + '/' + urlSubdirectory + '/' + lastSegment;
        const eventTypes = livliFamilyEvent.eventTypes?.map((type: string) => ({
          name: type,
        }));
        const slots = { variant: 'Today' };
        SetEventCard({
          ...livliFamilyEvent,
          slug,
          eventTypes,
          slots,
          node_locale,
        });
      } else {
        SetEventCard(livliFamilyEvent);
      }
    };
    getLatestLFData();
  }, [urlSubdirectory]);

  return (
    <>
      {eventCard && (
        <div className="mb-5 w-full ">
          <CardEvent
            card={eventCard}
            dictionary={dictionary}
            cardIndex={1}
            bodyMinHeight="210px"
            isLivliFamily={isLivliFamily}
          />
        </div>
      )}
    </>
  );
};

export default LivliFamilyCardEventWrapper;
